module.exports = __webpack_public_path__ + "img/vegetable-beets-190x100.90d5910d.jpg";